import React, {Component} from 'react';

import MainNavigation from '../components/MainNavigation';
import Toast from '../components/Toast';

class MainLayout extends Component{
	constructor(props){
		super(props);
		this.state = {
            showOtherMenu: false,
            showMenu: false
		}
		this.handleNavigation = this.handleNavigation.bind(this);
	}

	handleNavigation(showOtherMenu,showMenu){
		this.setState({
			showOtherMenu: showOtherMenu,
			showMenu: showMenu
		});
	}
	render(){
		const {component: Component, ...rest} = this.props;
		return (
			
				<div className="wrapper">
					<MainNavigation 
						showOtherMenu={this.state.showOtherMenu} 
						showMenu={this.state.showMenu} 
						handleNavigation={(showOtherMenu,showMenu) => this.handleNavigation(showOtherMenu,showMenu)}
						privileges = {this.props.privileges}
					/>
					<div className="main-layout" onClick={() => this.handleNavigation(false,false)}>
						<Component {...rest} />
						<Toast />
					</div>				
				</div>
		)
	}
}

export default MainLayout;